// extracted by mini-css-extract-plugin
module.exports = {"buttonInserts":"insertNames_buttonInserts__2sxlv"};